import React, {useMemo} from 'react';
import {Table, Button, Input, Dropdown, Grid} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {invoicesPageSizes} from '../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './tableFilters';

const columnsTable = [
  {
    'Header': 'Ruc',
    'accessor': 'ruc',
    'width': 150,
  },
  {
    'Header': 'Usuario',
    'accessor': 'user',
    'width': 150,
  },
  {
    'Header': 'Nombre',
    'accessor': 'name',
    'width': 250,
  },
  {
    'Header': 'Agencia',
    'accessor': 'agency',
    'width': 200,
  },
  {
    'Header': 'Número Pedido',
    'accessor': 'orderNumber',
    'width': 200,
  },
  {
    'Header': 'Fecha Pedido',
    'accessor': 'orderDate',
    'width': 200,
  },
  {
    'Header': 'Fecha Factura',
    'accessor': 'invoiceDate',
    'width': 200,
  },
  {
    'Header': 'Días Facturación',
    'accessor': 'diff',
    'width': 50,
  },
  {
    'Header': 'Código',
    'accessor': 'partno',
    'width': 100,
  },
  {
    'Header': 'Descripción',
    'accessor': 'partname',
    'width': 300,
  },
  {
    'Header': 'Cantidad solicitada',
    'accessor': 'quantityOrder',
  },
  {
    'Header': 'Cantidad Pendiente',
    'accessor': 'pendingOrder',
  },
  {
    'Header': 'Icc',
    'accessor': 'saleIcc',
  },
  {
    'Header': 'Estado',
    'accessor': 'status',
  },
  {
    'Header': 'Tipo Orden',
    'accessor': 'orderType',
  },
  {
    'Header': 'Tipo Item',
    'accessor': 'itemClas',
    'width': 150,
  },
  {
    'Header': 'Grupo',
    'accessor': 'tdeGroup',
    'width': 200,
  },
];

const BoReportTable = ({setReportList}) => {
  const data = useMemo(() => setReportList, []);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination
  );

  return (
    <>
      <div className='table-container'>
        <Table className='interactive' compact striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    className={index < 2 ? 'dropdown-header' : ''}
                    textAlign='center'
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i} {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign='center' {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      {page.length > 0 && (
        <Grid className='pagination'>
          <Grid.Row>
            <Grid.Column width={3} textAlign='left'>
              <Button
                className='navigation-button'
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content='Anterior'
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <span>páginas </span>
              <span>
                <Input
                  className='pages-input'
                  type='number'
                  value={pageIndex + 1}
                  min='1'
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Grid.Column>
            <Grid.Column width={5}>
              <Dropdown
                className='page-sizes-selection'
                selection
                upward
                compact
                value={pageSize}
                options={invoicesPageSizes}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span> filas</span>
            </Grid.Column>
            <Grid.Column width={3} textAlign='right'>
              <Button
                className='navigation-button'
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content='Siguiente'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
    </>
  );
};

export default BoReportTable;
